import PropTypes from "prop-types";
import { IoRocketSharp } from "react-icons/io5";
import {
  MdAccountCircle,
  MdFeedback,
  MdHistory,
  MdLogout,
  MdSettings
} from "react-icons/md";
import {
  TbLayoutSidebarLeftCollapse,
  TbLayoutSidebarRightCollapse,
} from "react-icons/tb";
import { useAuth } from "../../../contexts/AuthContext";
import styles from "./Sidebar.module.css";

const Sidebar = ({
  isCollapsed,
  onToggleCollapse,
  onOpenSettings,
  onFeedback,
  onLogout,
  activeTab,
  onTabChange,
}) => {
  const { user } = useAuth();
  const displayUser = user?.email || "User";
  return (
    <div className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ""}`}>
      {isCollapsed ? (
        <div className={styles.collapsedContent}>
          <div className={styles.collapsedLogo}>
            <img src="/favicon.ico" alt="Selene Logo" />
          </div>

          <div className={styles.navSection}>
            <button
              className={`${styles.navButton} ${activeTab === "playground" ? styles.active : ""}`}
              onClick={() => onTabChange("playground")}
              title="Playground"
            >
              <IoRocketSharp className={styles.navIcon} />
            </button>

            <button
              className={`${styles.navButton} ${activeTab === "history" ? styles.active : ""}`}
              onClick={() => onTabChange("history")}
              title="History"
            >
              <MdHistory className={styles.navIcon} />
            </button>
          </div>

          <button
            className={styles.settingsButton}
            onClick={onOpenSettings}
            aria-label="Open settings"
            title="Settings"
          >
            <MdSettings className={styles.settingsIcon} />
          </button>

          <button
            className={styles.feedbackButton}
            onClick={onFeedback}
            aria-label="Provide feedback"
            title="Provide Feedback"
          >
            <MdFeedback className={styles.feedbackIcon} />
          </button>
        </div>
      ) : (
        <div className={styles.sidebarContent}>
          <div className={styles.logoSection}>
            <img src="/assets/selene-logo.png" alt="Selene Logo" />
          </div>

          <div className={styles.navSection}>
            <button
              className={`${styles.navButton} ${activeTab === "playground" ? styles.active : ""}`}
              onClick={() => onTabChange("playground")}
            >
              <IoRocketSharp className={styles.navIcon} />
              <span>Playground</span>
            </button>

            <button
              className={`${styles.navButton} ${activeTab === "history" ? styles.active : ""}`}
              onClick={() => onTabChange("history")}
            >
              <MdHistory className={styles.navIcon} />
              <span>History</span>
            </button>
          </div>

          <div className={styles.section}>
            <button
              className={styles.settingsButton}
              onClick={onOpenSettings}
              aria-label="Open settings"
              title="Settings"
            >
              <MdSettings className={styles.settingsIcon} />
              <span>Settings</span>
            </button>
          </div>

          <div className={styles.section}>
            <button
              className={styles.feedbackButton}
              onClick={onFeedback}
              aria-label="Provide feedback"
              title="Provide Feedback"
            >
              <MdFeedback className={styles.feedbackIcon} />
              <span>Feedback</span>
            </button>
          </div>
        </div>
      )}

      <div
        className={styles.userProfile}
        onClick={isCollapsed ? onLogout : undefined}
        title={isCollapsed ? "Logout" : undefined}
        style={isCollapsed ? { cursor: "pointer" } : {}}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "var(--spacing-xs)",
            overflow: "hidden",
          }}
        >
          <MdAccountCircle className={styles.userIcon} />
          {!isCollapsed && (
            <span className={styles.username}>{displayUser}</span>
          )}
        </div>
        {!isCollapsed && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onLogout();
            }}
            title="Logout"
            style={{
              background: "transparent",
              border: "none",
              color: "var(--color-text-secondary)",
              cursor: "pointer",
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "4px",
              borderRadius: "4px",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.color = "var(--color-error)")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.color = "var(--color-text-secondary)")
            }
          >
            <MdLogout />
          </button>
        )}
      </div>

      <button
        className={styles.toggleButton}
        onClick={onToggleCollapse}
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        <span className={styles.toggleIcon}>
          {isCollapsed ? (
            <TbLayoutSidebarRightCollapse />
          ) : (
            <TbLayoutSidebarLeftCollapse />
          )}
        </span>
      </button>
    </div>
  );
};

Sidebar.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onToggleCollapse: PropTypes.func.isRequired,
  onOpenSettings: PropTypes.func.isRequired,
  onFeedback: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default Sidebar;
